import { cn } from "../lib/utils.js";
import { useFieldContext } from "./field-context.js";
import "react";
import { CheckIcon, MinusIcon } from "@phosphor-icons/react";
import { jsx } from "react/jsx-runtime";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
//#region src/components/checkbox.tsx
const CheckboxBase = ({ className, id, disabled, required, checked, ref, "aria-describedby": ariaDescribedBy, "aria-invalid": ariaInvalid, "aria-required": ariaRequired, ...props }) => {
	const ctx = useFieldContext();
	return /* @__PURE__ */ jsx(CheckboxPrimitive.Root, {
		ref,
		"data-slot": "checkbox",
		id: id ?? ctx?.id,
		disabled: disabled ?? ctx?.disabled,
		required: required ?? ctx?.required,
		"aria-describedby": ariaDescribedBy ?? ctx?.ariaDescribedBy,
		"aria-invalid": ariaInvalid ?? ctx?.invalid,
		"aria-required": ariaRequired ?? ctx?.required,
		checked,
		className: cn("tw:peer tw:size-4 tw:shrink-0 tw:rounded-sm tw:border tw:border-input tw:bg-background tw:p-0", "tw:shadow-xs tw:outline-none tw:cursor-pointer", "tw:focus-visible:ring-ring/50 tw:focus-visible:ring-[3px]", "tw:data-[state=checked]:bg-primary tw:data-[state=checked]:text-primary-foreground tw:data-[state=checked]:border-primary", "tw:data-[state=indeterminate]:bg-primary tw:data-[state=indeterminate]:text-primary-foreground tw:data-[state=indeterminate]:border-primary", "tw:disabled:cursor-not-allowed tw:disabled:opacity-50", "tw:aria-invalid:border-destructive", className),
		...props,
		children: /* @__PURE__ */ jsx(CheckboxPrimitive.Indicator, {
			className: "tw:flex tw:items-center tw:justify-center tw:text-current",
			children: checked === "indeterminate" ? /* @__PURE__ */ jsx(MinusIcon, {
				className: "tw:size-3",
				weight: "bold"
			}) : /* @__PURE__ */ jsx(CheckIcon, {
				className: "tw:size-3",
				weight: "bold"
			})
		})
	});
};
//#endregion
export { CheckboxBase };

//# sourceMappingURL=checkbox.js.map